import React from 'react';
import { ProductType } from '@/@types';
import { Trans } from '@lingui/macro';
import clsx from 'clsx';
import { Runtime } from '@/components/core/components/molecules';
import * as styles from './default.styles';

const DefaultDetails: React.FC<{ product: ProductType }> = ({ product }) => {
  return (
    <section>
      {product.description && (
        <div className={styles.overview}>
          <div className={clsx(styles.title)}>
            <Trans>Overview</Trans>
          </div>
          <span className={styles.details}>{product.description}</span>
        </div>
      )}

      {product.genres && product.genres.length > 0 && (
        <div className={styles.item}>
          <span className={styles.title}>
            <Trans>Genres</Trans>
          </span>
          <span className={styles.details}>{product.genres.join(', ')}</span>
        </div>
      )}

      {product.runtime > 0 && (
        <div className={styles.item}>
          <span className={styles.title}>
            <Trans>Duration</Trans>
          </span>
          <span className={styles.details}>
            <Runtime runtime={product.runtime} />
          </span>
        </div>
      )}

      {product.authors.length > 0 && (
        <div className={styles.item}>
          <span className={styles.title}>
            <Trans>Director</Trans>
          </span>
          <span className={styles.details}>{product.authors.join(', ')}</span>
        </div>
      )}
    </section>
  );
};

export default DefaultDetails;
